
document.addEventListener('DOMContentLoaded', () => {

    class CollectionBanner extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.setVisibility();
            this.forceImageHeight();
            this.addEventListener('click', (e)=>{
                if(this.dataset.clickAll){
                    const cta = this.querySelector('.collection-banner__cta');
                    if(cta != null && cta.getAttribute('href') != ''){
                        cta.click();
                    }
                }
            });
            window.addEventListener("filters-toggle", (e) => {
                this.setTextVisibility(e.detail.action);
                this.forceImageHeight();
            });
            window.addEventListener("resize", (e) => {
                this.forceImageHeight();
            });
        }

        setTextVisibility(action){
            const textBox = this.querySelector('.collection-banner__text');

            if(textBox){
                switch (action) {
                    case 'moving':
                        textBox.classList.add('transitioning');
                        break;

                    default:
                        textBox.classList.remove('transitioning');
                        break;
                }
            }
        }

        forceImageHeight(){
            const productImages = document.querySelectorAll('.product-grid .product-block__image');
            const productTiles = document.querySelectorAll('.product-grid > .product-block:not(.product-banner)');
            const mobileHeight = this.parentNode.dataset.mobileHeight;
            const desktopHeight = this.parentNode.dataset.desktopHeight;

            if (window.innerWidth > window.mobileBreakpoint){

                // Desktop banner
                const image = this.querySelector('.collection-banner__bg-image.-desktop');
                switch (desktopHeight) {
                    case 'productImageHeight':
                        if(productImages.length && image != null){
                            image.style.height = `${productImages[0].height}px`;
                        }
                        break;

                    case 'productTileHeight':
                        if(productTiles.length && image != null){
                            image.style.height = `${productTiles[0].clientHeight}px`;
                        }
                        break;
                }

            } else {

                // Mobile banner
                const image = this.querySelector('.collection-banner__bg-image.-mobile');

                switch (mobileHeight) {
                    case 'productImageHeight':
                        if(productImages.length && image != null){
                            image.style.height = `${productImages[0].height}px`;
                        }
                        break;

                    case 'productTileHeight':
                        if(productTiles.length && image != null){
                            image.style.height = `${productTiles[0].clientHeight}px`;
                        }
                        break;
                }
            }
        }

        setVisibility(){
            try {
                const urlParams = new URLSearchParams(window.location.search);
                const urlParamsArr = Array.from(urlParams);

                const whitelistedParams = window.shopConfig.collectionBannersParamsWhitelist.split(',');

                const notWhitelistedParams = urlParamsArr.filter(param => {
                    return !whitelistedParams.includes(param[0]);
                });

                if(notWhitelistedParams.length > 0 ) {
                    this.parentNode.style.display = 'none';
                } else {
                    this.parentNode.style.display = 'block';
                }

            } catch(e) {
                console.log("Error on PLP banner setVisibility: ", e);
            }
        }
    }

    customElements.define("collection-banner", CollectionBanner);

});

